// make relative paths on production since the configurator is not
// hosted in the root director of the server

export const PathPrefixPlugin = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$pathPrefix', {
      get: () => process.env.NODE_ENV === `production` 
        ? `.`
        : ``
    })
  }
}